import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'ngx-patientportalheaders',
  templateUrl: './patientportalheaders.component.html',
  styleUrls: ['./patientportalheaders.component.scss']
})
export class PatientportalheadersComponent implements OnInit {
  @Output() homeClick = new EventEmitter<void>();
  @Output() bookingClick = new EventEmitter<string>();
  @Output() profileClick = new EventEmitter<void>();
  @Output() onClickCountry = new EventEmitter<string>();
  user: any;
  countryCodeDropDownLists: Array<any> = [];
  selectedCountryCode: string = '';
  selectedCountryName: string = '';
  isregionSelected: boolean = false;
  protected readonly unsubscribe$ = new Subject<void>();
  count = 0;
  constructor(private router: Router,protected http:HttpClient,private patAptSrv: PatientAppointmentData,private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.user = localStorage.getItem('userName');
    this.loadCountryMaster();
  }

 gotoHome() {
    this.homeClick.emit(); 
  }

  gotoBooking(routingPath: string) {
    if(routingPath == 'doc'){
      localStorage.setItem('isPatientDoc', 'true');
    }
    this.bookingClick.emit(routingPath);  
  }

  onClickProfile() {
    this.profileClick.emit();
  }

  onClick(path: string) {
    this.router.navigate([`/pages/patient-portal/booking-newpage/fromPortal`], { queryParams: { path: path } });
  }

  loadCountryMaster(): void {
    this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.countryCodeDropDownLists = data.details;
        
      }, (error) => {
        if(error.status==401){
          this.router.navigateByUrl('/auth/patient-portal');
        }
      }, () => {
      if(this.count == 0 && this.countryCodeDropDownLists.length > 0){
        this.count++
        this.route.queryParams.subscribe(params => {
          const cc = params['cc'];
          if(cc){
            this.selectedCountryCode = this.countryCodeDropDownLists.find(country => country.countryCode === cc)?.id
          }
          
        });
      }
    });
  }

  onSelectCountryCode(event: any) {
    if(event){
      this.isregionSelected = true;
      this.selectedCountryCode = event[0]?.data?.id;
      this.selectedCountryName = event[0]?.data?.countryName;
      this.router.navigate([], {
        relativeTo: this.route, 
        queryParams: { cc: event[0]?.data?.countryCode },
        queryParamsHandling: 'merge', 
        replaceUrl: true     
      });
    this.onClickCountry.emit(this.selectedCountryName);
    } 
    
  }



}
